// ------------------------------------
// Constants
// ------------------------------------
import { createSelector } from 'reselect'
export const SET_REFERRER_ID = 'SET_REFERRER_ID'

// ------------------------------------
// Actions
// ------------------------------------
export function setReferrerId(payload) {
  return { type: SET_REFERRER_ID, payload }
}

// ------------------------------------
// Reducer
// ------------------------------------

export const getReferrerId = getState => getState.referrer.id

export const makeGetReferrerId = () => {
  return createSelector([getReferrerId], id => id)
}

const initialState = {
  id: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_REFERRER_ID:
      return {
        id: action.payload.id
      }
    default:
      return state
  }
}
